import { useEnvComposable } from '@/composables';
const hotjarOptions = {
  id: +import.meta.env.VITE_HOTJAR_ID,
  isProduction: useEnvComposable().env === 'production',
  snippetVersion: 6,
};

export default hotjarOptions;
